export interface EulaItem {
  title: string;
  selected: boolean;
  type: EulaType;
}

export enum EulaType {
  Default = 1,
  DeepRoots = 2,
  FreeTrial = 3,
}
